const config = {
  API_URL: process.env.REACT_APP_API_URL,
  API_URL_V2: process.env.REACT_APP_API_URL_V2,
};
export default config;
